<div class="z-fx-col z-fx-start-center z-fx-auto z-fx-w100 ai-settings">
  <div class="z-fx-col z-fx-w100 user-profile-settings">
    <div class="z-fx-col z-fx-start-center z-fx-gap-24 z-fx-w100 zef-card-z-1-soft user-profile-settings-content">
      <div class="accordion-content">
        <ng-container
          zefAccordion
          #userProfileAccordion="zefAccordion"
          [open]="(userProfileEditing$ | async) === true"
          (toggled)="userProfileEditing$.next($event)"
        >
          <ng-container *zefAccordionClosedContent>
            @if ((cf.aiLoading | async)?.length === 0) {
              <div
                class="z-fx z-fx-center-center z-fx-gap-8 z-fx-w100 rounded-8 border-2 border-solid border-space-dark p-16 hover:cursor-pointer hover:bg-space-dark"
                (click)="userProfileAccordion.toggle(true)"
              >
                <mat-icon
                  class="z-fx-none zef-icon-smaller"
                  [ngClass]="userProfile ? 'zef-gradient-ai zef-text-background-clip' : 'text-warning'"
                  matTooltip="Describing the report reader helps tailor the report"
                  i18n-matTooltip
                  matTooltipPosition="above"
                >
                  {{ userProfile ? 'bullet_done' : 'editor_alert' }}
                </mat-icon>
                @if (!userProfile) {
                  <div class="z-fx-auto zef-text-p2 text-center">
                    <span class="text-warning-dark" i18n>Describe the report reader</span>
                    <span>&nbsp;</span>
                    <span class="text-ink-lightest" i18n>for a more relevant report.</span>
                  </div>
                } @else {
                  <div class="zef-text-p2 z-fx z-fx-center-center z-fx-auto z-fx-gap-8 whitespace-nowrap text-center">
                    <span class="flex-initial text-ink-lightest" i18n>This report is tailored to</span>
                    <span class="zef-gradient-ai zef-text-background-clip overflow-hidden text-ellipsis">
                      {{ userProfile }}
                    </span>
                    <span class="zef-text-p3 flex-initial uppercase text-primary" i18n>Edit</span>
                  </div>
                }
              </div>
            }
          </ng-container>
          <ng-container *zefAccordionOpenedContent>
            <div class="zef-card-ai">
              <div class="zef-card-z0 flex flex-col gap-24 p-32">
                <div class="flex items-center gap-8">
                  <span class="zef-text-h3" i18n>Report Audience</span>
                  <mat-icon
                    [ngClass]="userProfile ? 'zef-gradient-ai zef-text-background-clip' : 'text-warning'"
                    matTooltip="Describing the report reader helps tailor the report"
                    i18n-matTooltip
                    matTooltipPosition="above"
                  >
                    {{ userProfile ? 'bullet_done' : 'editor_alert' }}
                  </mat-icon>
                  <span class="flex-auto"></span>
                  <button
                    mat-icon-button
                    (click)="userProfileAccordion.toggle(false); companyProfileUpdate.next([companyProfile, false])"
                  >
                    <mat-icon>pointer_collapse</mat-icon>
                  </button>
                </div>
                <span class="zef-text-p2 text-ink-lighter" i18n>
                  Describe who will be reading this report to help tailor the content and insights to their needs
                </span>

                <div class="z-fx-col z-fx-gap-16">
                  <mat-form-field class="w-100 rounded-16 rounded-br-none bg-space-darkest p-16">
                    <textarea
                      #userProfileInput
                      matInput
                      autoSize
                      [autoFocus]="true"
                      [autoSizeMinRows]="3"
                      placeholder="Describe the report reader..."
                      i18n-placeholder
                      [ngModel]="userProfile"
                      ngModel
                      (ngModelChange)="userProfileUpdate.next($event)"
                    ></textarea>
                  </mat-form-field>
                  <div class="z-fx-col z-fx-w100 z-fx-gap-16 z-fx-center-center">
                    <div class="z-fx z-fx-start-center z-fx-gap-4">
                      <div class="zef-text-h3" i18n>More context</div>
                      <button mat-icon-button (click)="showAdditionalContext = !showAdditionalContext">
                        <mat-icon>{{ showAdditionalContext ? 'pointer_up' : 'pointer_down' }}</mat-icon>
                      </button>
                    </div>

                    @if (showAdditionalContext) {
                      <div class="z-fx-col z-fx-w100 z-fx-gap-16">
                        <span class="zef-text-p2 text-ink-lighter" i18n>
                          Tell AI about the organization. This helps AI by giving better context for the analysis
                        </span>
                        @if (companyProfile) {
                          <mat-form-field class="w-100 rounded-16 rounded-br-none bg-space-darkest p-16">
                            <textarea
                              #companyProfileInput
                              matInput
                              autoSize
                              [autoFocus]="true"
                              [autoSizeMinRows]="3"
                              placeholder="Describe the company..."
                              i18n-placeholder
                              [(ngModel)]="companyProfile"
                              ngModel
                              (ngModelChange)="companyProfileUpdate.next([$event, true])"
                            ></textarea>
                          </mat-form-field>
                        } @else {
                          <mat-form-field
                            *ngIf="{ loading: companyProfileLoading$ | async } as $"
                            class="z-search-field url-search-field"
                          >
                            @if (!$.loading) {
                              <mat-icon class="zef-gradient-ai zef-text-background-clip" matPrefix>world</mat-icon>
                            } @else {
                              <zef-spinner-ai-loading
                                class="zef-gradient-ai zef-button-prefix small"
                                matPrefix
                              ></zef-spinner-ai-loading>
                            }
                            <input
                              #companyProfileUrlInput
                              matInput
                              autoSize
                              [autoFocus]="true"
                              placeholder="Paste company URL... or write your own description"
                              i18n-placeholder
                              (change)="updateContext(companyProfileUrlInput.value)"
                              (keyup)="detectExpandNeed(companyProfileUrlInput.value)"
                            />
                          </mat-form-field>
                        }
                      </div>
                    }
                  </div>
                  <div class="z-fx z-fx-between-center z-fx-gap-16">
                    <div class="z-fx z-fx-start-center">
                      @if (showLanguages) {
                        <zef-select [value]="activeLanguage" (change)="changeLanguage($event)">
                          <zef-select-option
                            *ngFor="let lang of languages"
                            [value]="lang.code"
                            [class.flag-option]="!isOtherLanguage(lang)"
                            [ngSwitch]="isOtherLanguage(lang)"
                          >
                            <div *selectPrefix>
                              <mat-icon *ngSwitchCase="true" color="ink" class="flag">flag</mat-icon>

                              <span
                                *ngSwitchCase="false"
                                class="zef-flag-tiny"
                                [ngClass]="'zef-lang-' + lang.code"
                              ></span>
                            </div>

                            <div *selectOptionLabel class="zef-color-ink zef-text-ellipsis">
                              {{ lang.name }}
                            </div>
                          </zef-select-option>
                        </zef-select>
                      }
                    </div>
                    <div class="z-fx z-fx-gap-16">
                      @if (aiGridChanges) {
                        <button
                          mat-raised-button
                          class="zef-combo-button"
                          (click)="userProfileAccordion.toggle(false); userProfileUpdate.next(userProfile)"
                        >
                          <strong i18n>Cancel</strong>
                        </button>
                        <button
                          class="zef-combo-button"
                          mat-raised-button
                          color="success"
                          (click)="userProfileAccordion.toggle(false); regenerateGrid(userProfileInput.value)"
                        >
                          <mat-icon>refresh_ai</mat-icon>
                          <span i18n>Update report</span>
                        </button>
                      } @else {
                        <button
                          mat-raised-button
                          class="zef-combo-button"
                          (click)="userProfileAccordion.toggle(false); regenerateGrid()"
                        >
                          <mat-icon>refresh_ai</mat-icon>
                          <span i18n>Regenerate report</span>
                        </button>
                        <button
                          mat-raised-button
                          class="zef-combo-button"
                          color="primary"
                          (click)="userProfileAccordion.toggle(false)"
                        >
                          <strong i18n>Done</strong>
                        </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      @if ((cf.aiLoading | async)?.length === 0) {
        @if ((userProfileEditing$ | async) === false) {
          @if (aiGridChanges && !hideChangesAvailableAd) {
            <div class="z-fx z-fx-center-center z-fx-gap-16">
              <div class="zef-text-p2-muted zef-text-with-spacing">
                <span class="text-warning-dark" i18n>Changes detected in report...</span>
                <span class="zef-text-p2-link-muted" (click)="regenerateGrid()" i18n>Update</span>
              </div>
              <button mat-icon-button (click)="hideChangesAvailableAd = true">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
          @if (showExecutiveSummaryButton() && !hideExecutiveSummaryAd) {
            <div class="z-fx z-fx-center-center z-fx-w100 z-fx-gap-16">
              <div class="zef-text-p2-muted zef-text-with-spacing">
                <span i18n>Psst... You have not generated Executive Summary yet.</span>
                <span class="zef-text-p2-link-muted" (click)="updateExecutiveSummary.emit()" i18n>Generate it!</span>
              </div>
              <button mat-icon-button (click)="hideExecutiveSummaryAd = true">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        }
      }
    </div>
  </div>
</div>
